import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSnackbar } from 'notistack';

import { notifyBackgroundTask } from '../bg_tasks/batchResponseHelper';
import { BackgroundTaskContext } from '../bg_tasks/BackgroundTaskProvider';
import PageHeading from '../components/PageHeading';
import PageMeta from '../components/PageMeta';
import BookingSyncForm from '../sync/bookings/BookingSyncForm';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        maxWidth: 900,
    },
}));

// Settings › Sync Bookings (also Ops › Sync Bookings): the booking sync form with its own scope pickers
// (licensee, booking system, account). A started run is announced with "View", which opens the Background
// tasks dialog on it.
const SyncBookingsPage = () => {
    const classes = useStyles();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const bgCtx = React.useContext(BackgroundTaskContext);

    const onLaunched = React.useCallback((taskId, task) => {
        notifyBackgroundTask({ statusCode: 202, data: task }, enqueueSnackbar, closeSnackbar, bgCtx);
    }, [enqueueSnackbar, closeSnackbar, bgCtx]);

    return (
        <div className={classes.root}>
            <PageMeta title="Sync Bookings" />
            <PageHeading sx={{ mb: 1 }}>Sync Bookings</PageHeading>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                Fetch bookings from an integration and import them.
                The operation runs in the background — you can monitor progress
                via the background operations panel.
            </Typography>
            <BookingSyncForm onLaunched={onLaunched} />
        </div>
    );
};

export default SyncBookingsPage;
